import React from "react";
import { CheckCircle, Error, RadioButtonUnchecked } from "@material-ui/icons";
import { Tooltip } from "@material-ui/core";
import { ValidateCustomerContractOptionResult } from "@api/timereports";

export function getValidationIcon(item: ValidateCustomerContractOptionResult) {
  if (!item) {
    return <RadioButtonUnchecked color="disabled" />;
  }

  return item.isValid ? (
    <Tooltip
      title={
        <div>
          Payment: {item.paymentStrategyName}
          <br />
          Schedule: {item.scheduleStrategyName}
        </div>
      }
    >
      <CheckCircle color={"secondary"} />
    </Tooltip>
  ) : (
    <Tooltip title={`Error: ${item.invalidReason}`}>
      <Error color={"primary"} />
    </Tooltip>
  );
}
